import {profileApi} from "../components/api/api";

const SET_PROFILE = 'SET_PROFILE';
const SET_ERROR = 'SET_ERROR';

let initialState = {
    first_name: null,
    last_name: null,
    email: null,
    avatar: null,
    aboutUser: null,
    phone: null,
    role: null,
    date_registration: null,
    owner_apartments: [],
    history_booked_apartments: [],
    history_reservation_apartment: [],
    user_messages: null,
    rating: 0,
    activatedByEmail: false,
    isLogin: false,
    isError: false,
    errorText: null
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILE: {
            return {...state, ...action.data, isLogin: true}
        }
        case SET_ERROR: {
            return {...state, ...action.data, errorText: action.errorText, isError: true}
        }
        default:
            return state;
    }
};

export const setProfile = (profile) => ({
    type: SET_PROFILE, data: {...profile}
});
export const setError = (errorText) => ({
    type: SET_ERROR, errorText: errorText
});
export const getProfile = (email, password, rememberMe) => {
    return (dispatch) => {
        profileApi.loginUser(email, password, rememberMe)
            .then(data => {
                dispatch(setProfile(data));
            }).catch((error) => {
            if (error) {
                dispatch(setError("Wrong email or password"));
            }

        });
    }
};
export const registrationProfile = (first_name, last_name, email, password) => {
    return (dispatch) => {
        profileApi.registrationUser(first_name, last_name, email, password)
            .then(data => {
                dispatch(setProfile(data));
            }).catch((error) => {
            if (error.request) {
                if (error.request.status == 400) {
                    dispatch(setError(
                        "Error! Bad email or password"))
                }
                if (error.request.status == 409) {
                    dispatch(setError("User with this email all ready exist!"))
                }
                console.log(error.request);
                console.log(error.request.status);
            } else if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else {
                dispatch(setError(error.message))
                console.log('Error', error.message);
            }

        });
    }
};

export default profileReducer;